<script setup>
import { computed, defineProps } from 'vue'

import MetricCardTitle from '@/views/dashboard/components/MetricCardTitle.vue'
import arrow from '@/assets/img/arrow.svg'

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  tooltip: {
    type: String
  },
  value: {
    type: Number,
    required: true
  },
  unit: {
    type: String,
    required: true
  },
  growth: {
    type: Number,
    required: true
  }
})

// 格式化数字为千分位
const numberFormat = new Intl.NumberFormat('en-US')
const formattedNumber = computed(() => {
  return numberFormat.format(props.value)
})
const growthClass = computed(() => {
  if (props.growth > 0) {
    return 'up'
  } else if (props.growth < 0) {
    return 'down'
  } else {
    return 'equal'
  }
})
</script>

<template>
  <div class="metric-card">
    <div class="metric-card__header">
      <MetricCardTitle :title="title" :tooltip="tooltip" />
    </div>
    <div class="metric-card__body">
      <span class="number">{{ formattedNumber }}</span>
      <arrow class="growth__arrow" :class="growthClass" />
      <span class="growth__number" :class="growthClass">{{ Math.abs(growth) }}%</span>
      <!--      <span class="unit">{{ unit }}：</span>-->
    </div>
  </div>
</template>

<style scoped lang="scss">
.metric-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 50%;
  margin-bottom: 1rem;

  &__body {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    margin: auto;
    width: fit-content;
    line-height: 1;

    .growth__arrow {
      flex-shrink: 0;
      width: 1rem;
      aspect-ratio: 1 / 1;
    }

    .growth__number {
      flex-shrink: 0;
      font-size: 1rem;
      font-weight: 800;
    }

    .unit {
      flex-shrink: 0;
      font-size: var(--font-size-sm);
      color: var(--color-text);
      line-height: 1.5;
    }

    .number {
      flex-shrink: 0;
      margin-right: 0.5rem;
      font-size: 2rem;
      font-weight: 800;
      color: var(--color-primary-dark);
    }
  }
}

.up {
  //color: var(--az-color-green-60);
  color: var(--color-primary);
}

.down {
  //color: var(--az-color-mulberry-60);
  color: var(--az-color-green-60);
}

.equal {
  color: var(--az-color-gray-100);
}

.growth__arrow.down {
  transform: rotate(180deg)
}

.growth__arrow.equal {
  transform: rotate(90deg)
}
</style>
